export default "__VITE_ASSET__DoMD7K5E__"